import React, { lazy, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import SnapcareChat from './containers/chat/SnapcareChat';
import SettingsSidebar from './containers/provider_settings/SettingsSidebar';
import SCLauncher from './containers/SupportChat';
import InteractionsTable from './containers/PatientInteractions/InteractionsTable';
import OutComesView from './containers/PatientOutcomes/OutComesView';
import { connectSocket } from './containers/chat/actions';
import { useExternalContact } from './hooks/useExternalContacts';
import QMEExternalContactsForm from './containers/qme-ame/QMEExternalContactsForm';
import EmployerInformationForm from './containers/qme-ame/EmployerInformationForm';
import InjuryInformationForm from './containers/qme-ame/InjuryInformationForm';
import { useLocalStorage } from '@rehooks/local-storage';

const RxOrder = lazy(() => import('./containers/RxOrders/RxOrder'));
const AddPatient = lazy(() => import('./containers/Patient/AddPatient'));
const Home = lazy(() => import('./containers/Home/Home'));
const NavigationBar = lazy(() => import('./containers/Navbar/Navbar'));
const Login = lazy(() => import('./containers/login/Login'));
const PatientEncounterFormv3 = lazy(() => import('./containers/EncounterNote/EncounterNoteV3'));
const EncounterChartML = lazy(() => import('./containers/EncounterNote/EncounterChartML'));
const RequestAppointmentService = lazy(() => import('./containers/AppointmentService/RequestAppointmentService'));
const PatientHome = lazy(() => import('./containers/AppointmentService/PatientHome'));
const SupportPage = lazy(() => import('./containers/AppointmentService/SupportPage'));
const ServicesOverviewByDate = lazy(() => import('./containers/AppointmentService/ServicesOverviewByDate'));
const SecureShare = lazy(() => import('./containers/SecureShare/index'));
const CreateSecureShareDoc = lazy(() => import('./containers/SecureShare/CreateSecureShareDoc'));
const ChangePassword = lazy(() => import('./containers/provider_settings/ChangePassword'));
// const RxOrder = lazy(() => import());
// const RxOrder = lazy(() => import());
const RxMedication = lazy(() => import('./containers/RxMedications/RxMedication'));
const ExternalContactLogin = lazy(() => import('./containers/login/ExternalContactLogin'));
const MrrSummaries = lazy(() => import('./containers/EncounterNote/MrrSummaries'));
const MedicalEvaluationDetails = lazy(() => import('./containers/qme-ame/MedicalEvaluationDetails'));
const Workflow = lazy(() => import('./containers/workflow/Workflow'));
const StaffTeleMedCheckIn = lazy(() => import('./containers/telemed/StaffTeleMedCheckIn'));

const QMEAppointmentInfoForm = lazy(() => import('./containers/qme-ame/QMEAppointmentInfoForm'));
const ClaimantInfoForm = lazy(() => import('./containers/qme-ame/ClaimantInfoForm.js'));
const LoginKuraMD = lazy(() => import('./containers/login/LoginKuraMD'));
const HomeKuraMD = lazy(() => import('./containers/Home/HomeKuraMD'));
const KuraMDEncounterRedirect = lazy(() => import('./containers/EncounterNote/KuraMDEncounterRedirect'));

// const ErrorPage = () => <div>404 Not Found</div>;

const RouteContainer = (props) => {
  console.log(props);
  const [type] = useLocalStorage('__type__');
  const [token] = useLocalStorage('__token__');
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(connectSocket());
  // }, []);
  if (!!token) {
    return (
      <div style={{ height: '100%' }} id={'router-main-div'}>
        {props.location.pathname.includes('encounter/2.0/edit') ||
        props.location.pathname.includes('encounter/2.5/edit') ||
        props.location.pathname.includes('encounter/3.0/edit') ||
        props.location.pathname.includes('mrr') ||
        props.location.pathname.includes('create_rx_order') ||
        props.location.pathname.includes('chart_ml') ||
        props.location.pathname.includes('telemed') ||
        props.location.pathname.includes('kura') ||
        props.location.pathname.includes('create_rx_medication') ? null : (
          <NavigationBar props={props} />
        )}
        {/* {props.location.pathname.includes('/messages') ? null : <SCLauncher />} */}
        {/*{!isExternalContact && (*/}
        {/*  <div style={{ height: '90%' }} id={'provider-routes'}>*/}
        <Route path={'/request_appt_service'} exact component={RequestAppointmentService} />
        <Route path={'/request_appt_service/patient/:id'} exact component={RequestAppointmentService} />
        <Route path={'/services_overview'} exact component={ServicesOverviewByDate} />
        <Route path={'/appointment'} exact component={Home} />
        <Route path={'/messages'} exact component={SnapcareChat} />
        <Route path={'/messages/patient/:id'} exact component={SnapcareChat} />
        <Route path={'/settings'} exact component={SettingsSidebar} />
        <Route path={'/support'} exact component={SupportPage} />
        <Route path={'/patient/:patientId'} exact component={PatientHome} />
        <Route path={'/patient/:patientId/folders'} exact component={PatientHome} />
        <Route path={'/patient/:id/create_rx_order'} exact component={RxOrder} />
        <Route path={'/patient/:id/create_rx_medication'} exact component={RxMedication} />
        <Route path={'/patient/:id/encounter/3.0/edit/:encounterId'} exact component={PatientEncounterFormv3} />
        <Route path={'/patient/:id/chart_ml/:encounterId'} exact component={EncounterChartML} />
        <Route path={'/patient/:id/scribe_intake/:encounterId'} exact component={EncounterChartML} />
        <Route path={'/add_patient'} exact component={AddPatient} />
        <Route path={'/appointment/add_patient'} exact component={AddPatient} />
        <Route path={'/change_password'} exact component={ChangePassword} />
        <Route path={'/qme_appointment/:appointmentId/'} exact component={MedicalEvaluationDetails} />
        <Route path={'/patient/:patientId/appointment/:appointmentId/mrr'} exact component={MrrSummaries} />
        <Route path={'/qme_external_contacts/:appointmentId'} exact component={QMEExternalContactsForm} />
        <Route path={'/qme_injury_info/:appointmentId'} exact component={InjuryInformationForm} />
        <Route path={'/qme_employer_info/:appointmentId'} exact component={EmployerInformationForm} />
        <Route path={'/qme_claimant_info/:chrPatientId'} exact component={ClaimantInfoForm} />
        <Route path={'/qme_appt_info/:appointmentId'} exact component={QMEAppointmentInfoForm} />
        <Route path={'/workflows'} exact component={Workflow} />
        <Route path={'/telemed_check_in'} exact component={StaffTeleMedCheckIn} />
        <Route path={'/patient_interactions'} exact component={InteractionsTable} />
        <Route path={'/patient/:patientId/survey_outcomes/:surveyId'} exact component={(props) => <OutComesView showClose {...props} />} />
        {/*  </div>*/}
        {/*)}*/}
        <Route path={'/secure_share'} exact>
          <SecureShare />
        </Route>
        <Route path={'/secure_share/create'} exact>
          <CreateSecureShareDoc />
        </Route>
        {type === 'KuraMDMrr' && <Route path={'/link2_md/home/appointment/:appointmentId'} exact component={HomeKuraMD} />}
        {type === 'KuraMDMrr' && <Route path={'/encounter/:kuraEncounterId/mrr'} exact component={KuraMDEncounterRedirect} />}
      </div>
    );
  }
  if (!!!token && props?.location?.pathname.includes('encounter') && props?.location?.pathname.includes('mrr')) {
    return <Redirect to={{ pathname: '/link2_md/login', state: { from: props.location.pathname } }} />;
  } else {
    return <Redirect to={{ pathname: '/login', state: { from: props.location.pathname } }} />;
  }
};
const Routes = () => (
  <Switch>
    <Route path={'/login'} exact component={Login} />
    <Route path={'/contact_login'} exact component={ExternalContactLogin} />
    <Route path={'/link2_md/login'} exact component={LoginKuraMD} />
    <Route exact path={'/'} component={() => <Redirect to={'/appointment'} />} />
    <Route component={RouteContainer} />
  </Switch>
);

RouteContainer.propTypes = {
  location: PropTypes.object,
};
export default Routes;
